import { utilToUiDate } from 'app/home/common/utils/iso-date-type/to-iso-date';
import { AboutYouQuoteFormInput } from 'app/home/create-quote/forms/about-you/about-you.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function aboutYouQuoteFormSelector(store: QuoteDraftSelectorState): AboutYouQuoteFormInput {
  const { applicant, hasOptedIntoSms, anonymousId } = store;
  const dob = applicant()?.dob;
  const formattedDob = dob ? utilToUiDate(dob) : '';
  const email = applicant()?.email ?? '';
  const firstName = applicant()?.firstName ?? '';
  const lastName = applicant()?.lastName ?? '';
  const phoneNumber = applicant()?.phoneNumber ?? '';

  return {
    dob: formattedDob ?? '',
    email,
    firstName,
    lastName,
    phoneNumber,
    optOutGpcTracking: false,
    hasOptedIntoSms: hasOptedIntoSms() ?? false,
    anonymousId: anonymousId() ?? '',
  };
}

export function aboutYouQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store['about-you']();
}
